import { useQuery } from '@tanstack/react-query';
import { getCloudEntryByComponentEntryId } from './request.get-cloud-entries.js';

const getCloudEntriesQueryKey = componentEntryId => ["component-framework/get-cloud-entries", componentEntryId];
const getCloudEntriesQuery = componentEntryId => {
  return {
    queryKey: getCloudEntriesQueryKey(componentEntryId),
    queryFn: () => getCloudEntryByComponentEntryId(componentEntryId)
  };
};
const useGetCloudEntriesQuery = (componentEntryId, extraConfig) => {
  return useQuery({
    ...getCloudEntriesQuery(componentEntryId),
    ...extraConfig
  });
};

export { getCloudEntriesQuery, getCloudEntriesQueryKey, useGetCloudEntriesQuery };
//# sourceMappingURL=query.get-cloud-entries.js.map
